import React, { FunctionComponent, PropsWithChildren, ReactElement } from 'react'
import './Speech.scss'

export interface OwnProps {
  propClassName?: string
}

type Props = PropsWithChildren<OwnProps>

export const Speech: FunctionComponent<Props> = ({
  propClassName = '',
  children,
}: Props): ReactElement => {
  const className = `Speech ${propClassName}`

  return (
    <div className={className}>
      <p className="Speech-inner">
        {children}
      </p>
    </div>
  )
}

export default Speech
